import type { FieldLocation } from '../hooks/useCrossFieldNavigation';

export type CrossFieldNavContext = {
  fieldName: string;
  currentLocation: FieldLocation;
  allLocations: FieldLocation[];
  triggerButtonRect: DOMRect;
  onNavigate: (sectionId: string, fieldName: string) => void;
};

let currentContext: CrossFieldNavContext | null = null;

export const CROSS_FIELD_NAV_OPEN_EVENT = 'crossFieldNav:open';
export const CROSS_FIELD_NAV_CLOSE_EVENT = 'crossFieldNav:close';

export function setCrossFieldNavContext(ctx: CrossFieldNavContext) {
  currentContext = ctx;
}

export function getCrossFieldNavContext() {
  return currentContext;
}

export function openCrossFieldNav() {
  document.dispatchEvent(new CustomEvent(CROSS_FIELD_NAV_OPEN_EVENT));
}

export function closeCrossFieldNav() {
  document.dispatchEvent(new CustomEvent(CROSS_FIELD_NAV_CLOSE_EVENT));
}
